<template>
	<v-dialog v-model="dialog" persistent max-width="400" scrollable>
		<v-card>
			<v-card-title class="justify-space-between">
				<div class="font-size-14 cl-secondary">Bonus Unilevel</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-col class="px-0 cl-secondary font-size-11 font-weight-500 border-top border-grey">
					<div class="pt-2">
						<v-row v-for="i in 10" :key="i">
							<v-col cols="6" class="pb-0">
								<div>Level {{ i }}</div>
							</v-col>
							<v-col cols="6" class="pb-0 text-right">
								<div>Rp 2.500.000</div>
							</v-col>
						</v-row>
					</div>
				</v-col>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>

export default {
	data () {
		return {
			dialog: false
		}
	},
	computed:{

	},
	props: {
		
	},
	methods :{
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
		},
		
	}
};
</script>